import './src/vaadin-tabsheet.js';
export * from './src/vaadin-tabsheet.js';
